import { useEffect, useState } from 'react';
import { operationalRealtimeClient } from '../realtime/operationalRealtimeClient';
import { isCollabPresenceEnabled, isCollabRealtimeEnabled } from './collabFeatureFlags';

type PresenceUser = { userId: number; displayName: string; role: string; activity?: string };

export function useWorkspaceCollaboration(userId?: number): {
  workspaceUsers: PresenceUser[];
  financeUsers: PresenceUser[];
} {
  const [workspaceUsers, setWorkspaceUsers] = useState<PresenceUser[]>([]);
  const [financeUsers, setFinanceUsers] = useState<PresenceUser[]>([]);

  useEffect(() => {
    if (!userId || !isCollabRealtimeEnabled() || !isCollabPresenceEnabled()) return;
    if (!operationalRealtimeClient.isConnected()) return;

    operationalRealtimeClient.collabWorkspacePing('workspace_overview');
    const timer = window.setInterval(() => {
      operationalRealtimeClient.collabWorkspacePing('workspace_overview');
      operationalRealtimeClient.collabFinancePing();
    }, 30_000);

    const unsub = operationalRealtimeClient.onCollab((msg) => {
      if (msg.kind === 'workspace_presence') {
        const activeUsers = Array.isArray(msg.payload.activeUsers)
          ? (msg.payload.activeUsers as PresenceUser[])
          : [];
        setWorkspaceUsers(activeUsers);
      }
      if (msg.kind === 'finance_presence') {
        const activeUsers = Array.isArray(msg.payload.activeUsers)
          ? (msg.payload.activeUsers as PresenceUser[])
          : [];
        setFinanceUsers(activeUsers);
      }
    });

    return () => {
      clearInterval(timer);
      unsub();
      setWorkspaceUsers([]);
      setFinanceUsers([]);
    };
  }, [userId]);

  return { workspaceUsers, financeUsers };
}
